export const checkHostnames = (value) => {
    value = Array.isArray(value) ? value : [value];
    const hostname = window.location.hostname;
    return value.some(item => {
        switch (true) {
            case item instanceof RegExp: return item.test(hostname);
            case typeof item === 'string':
            default: return item === hostname;
        }
    });
};
//# sourceMappingURL=hostnames.js.map